import { render, staticRenderFns } from "./LavorazioniSub.vue?vue&type=template&id=02a1543b"
import script from "./LavorazioniSub.vue?vue&type=script&lang=js"
export * from "./LavorazioniSub.vue?vue&type=script&lang=js"
import style0 from "./LavorazioniSub.vue?vue&type=style&index=0&id=02a1543b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports